import React from "react";

const MPP = () => {
  return (
    <>
      <h4 style={{ textAlign: "center" }}>प्रेस विज्ञप्ति</h4>
      <h3 style={{ textAlign: "center" }}>
        नेपाल विश्वविद्यालयको पहिलो शैक्षिक कार्यक्रम सुरु
      </h3>

      <br />

      <p>
        गुणस्तरीय शिक्षा र व्यावहारिक सीपमार्फत आर्थिक–सामाजिक रूपान्तरणमा सक्षम
        तथा प्रतिस्पर्धी जनशक्ति तयार गर्ने उद्देश्यले स्थापित नेपाल
        विश्वविद्यालयले आफ्नो पहिलो शैक्षिक कार्यक्रमको रूपमा 'मास्टर अफ पब्लिक
        पोलिसी' मा भर्ना खुला गरेको छ।
      </p>

      <p>
        राज्यका निकाय, निजी क्षेत्र, अन्तर्राष्ट्रिय संस्था तथा अन्य गैर–सरकारी
        क्षेत्रलाई आवश्यक सार्वजनिक नीतिमा सक्षम र प्रतिस्पर्धी जनशक्ति तयार
        गर्नु यस कार्यक्रमको मुख्य लक्ष्य हो। विषयवस्तुको गहिरो ज्ञान,
        विश्लेषणात्मक दक्षता र नीति निर्माणका व्यवहारिक सीपलाई समेटेर यो दुई
        वर्षे पूर्णकालीन शैक्षिक कार्यक्रम तयार गरिएको छ।
      </p>

      <p>
        ख्यातिप्राप्त विदेशी विश्वविद्यालयका प्राज्ञ तथा सार्वजनिक नीति
        क्षेत्रका विभिन्न सरोकारवाला संस्थाका प्रतिनिधिहरूको सहभागितामा यस
        कार्यक्रमको पाठ्यक्रम विकास गरिएको हो। विद्यार्थी–केन्द्रित पठन–पाठन
        पद्धति र अन्य प्राज्ञिक तथा बौद्धिक गतिविधिहरूमार्फत सार्वजनिक नीति
        क्षेत्रमा राष्ट्रिय तथा अन्तर्राष्ट्रिय स्तरका बौद्धिक नेतृत्व तयार हुने
        अपेक्षा गरिएको छ।
      </p>

      <p>
        यो कार्यक्रम नेपाल विश्वविद्यालयको पहिलो शैक्षिक कार्यक्रम भएकाले पहिलो
        ब्याचका लागि उल्लेख्य संख्यामा छात्रवृत्तिको व्यवस्था पनि गरिएको छ।
      </p>

      <p>
        गुणस्तरीय शिक्षाको आधारमा पेशागत विकासको चाहना राख्ने विद्यार्थी तथा यस
        क्षेत्रमा आफ्नो दक्षता अभिवृद्धि गर्न चाहने पेशाकर्मीहरूले २०८२ माघ ८
        (२२ जनवरी २०२६) सम्म भर्नाका लागि आवेदन दिन सक्नेछन्।
      </p>

      <br />

      <p>
        सूर्यराज आचार्य <br />
        रजिस्ट्रार, नेपाल विश्वविद्यालय <br />
        निर्देशक, स्कूल अफ पब्लिक पोलिसी
      </p>
    </>
  );
};

export default MPP;
